import script from "./OperatorBuddyListOrderConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorBuddyListOrderConfig.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorBuddyListOrderConfig.vue?vue&type=style&index=0&id=1a4e6748&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a4e6748"]])

export default __exports__